import { render, staticRenderFns } from "./zhichanyun.vue?vue&type=template&id=34949954&scoped=true"
import script from "./zhichanyun.vue?vue&type=script&lang=js"
export * from "./zhichanyun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34949954",
  null
  
)

export default component.exports